import { fork, all } from 'redux-saga/effects';

import { sagas as Login } from 'containers/Login';
import { sagas as ForgotCredentials } from 'containers/ForgotCredentialsModal';

function* rootSaga() {
  yield all([
    fork(Login),
    fork(ForgotCredentials)
  ]);
}

export default rootSaga;
